import RouterLink from '@/components/RouterLink.jsx';
import colors from '@assets/theme/base/colors';

const { secondary } = colors;

const buttonBase = {
  defaultProps: {
    disableRipple: false,
    LinkComponent: RouterLink,
  },
  styleOverrides: {
    root: {
      '&:hover, &:focus': {
        outline: `3px solid ${secondary.dark}`,
      },
      '&:disabled': {
        cursor: 'not-allowed !important',
      },
    },
  },
};

export default buttonBase;
